import { ContentWrapper } from 'app/pages/library/videos/videoList/components/SendAndShare/send/SendTab';
import styled, { css } from 'styled-components/macro';

export const FullScreenModalContent = styled(ContentWrapper)`
  margin-top: 0;
  display: flex;
  flex-direction: column;
  width: 956px;
  padding-bottom: 0;
`;

export const EmptySearch = styled.div`
  display: flex;
  height: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
  width: 100%;
  min-height: 530px;
`;

export const FullScreenModalFooter = styled(ContentWrapper)`
  display: flex;
  justify-content: flex-end;
  margin-top: 32px;
  padding-bottom: 0;
`;

export const VideosList = styled.div`
  width: 100%;
  min-height: 530px;
`;

export const VideoRow = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  height: 56px;
  border-bottom: 1px solid rgb(223, 227, 230);
`;

export const BaseModalText = styled.div`
  height: 24px;
  margin-left: 24px;
  font-size: 16px;
  line-height: 1.5;
  text-align: left !important;
  color: ${props => props.theme.colors.neutral[100]};
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1; /* number of lines to show */
  -webkit-box-orient: vertical;
`;

export const BaseHeaderText = styled(BaseModalText)`
  font-size: 14px;
  color: ${props => props.theme.colors.neutral[60]};
  display: flex;
`;
// vehicle year
export const VehicleYearWidth = css`
  max-width: 185px;
  min-width: 80px;
`;
export const VehicleYear = styled(BaseModalText)`
  ${VehicleYearWidth}
`;

export const VehicleYearHeader = styled(BaseHeaderText)`
  ${VehicleYearWidth}
`;
// vehicle make
export const VehicleMakeWidth = css`
  max-width: 180px;
  min-width: 130px;
`;
export const VehicleMake = styled(BaseModalText)`
  ${VehicleMakeWidth}
`;
export const VehicleMakeHeader = styled(BaseHeaderText)`
  ${VehicleMakeWidth}
`;
// vehicle model
export const VehicleModelWidth = css`
  width: inherit;
`;
export const VehicleModel = styled(BaseModalText)`
  ${VehicleModelWidth}
`;

export const VehicleModelHeader = styled(BaseHeaderText)`
  ${VehicleModelWidth}
`;

export const PreviewModelHeader = styled(BaseHeaderText)`
  width: 105px;
  margin-left: 0;
`;
